import { call, put, takeLatest } from "redux-saga/effects";
import {
    addBookingApi,
    getCustomerApi,
    getVehicleTypesApi,
    getTripTypesApi,
    getGoodsTypesApi,
    getLocationsApi,
    getAvailableCabsApi,
    getMeterFareApi,
    getIntercityListApi,
    getReturnIntercityApi,
    getPackagesApi,
    getBranchesApi,
    addEnquiryApi,
    getNightFareApi,
    getEnquiryByDateApi,
    enquiryToNewBookingApi,
    getDistanceApi,
    getCompaniesApi,
    getNewBookingEditApi,
    updateEnquiryApi,
    enquiryAssignTripApi,
} from "../../utils/booking/Booking";
import {
    ADD_BOOKING_REQUEST,
    ADD_BOOKING_SUCCESS,
    ADD_BOOKING_FAILURE,
    GET_CUSTOMER_REQUEST,
    GET_CUSTOMER_SUCCESS,
    GET_CUSTOMER_FAILURE,
    GET_VEHICLE_TYPES_REQUEST,
    GET_VEHICLE_TYPES_SUCCESS,
    GET_VEHICLE_TYPES_FAILURE,
    GET_TRIP_TYPES_REQUEST,
    GET_TRIP_TYPES_SUCCESS,
    GET_TRIP_TYPES_FAILURE,
    GET_INTERCITY_LIST_REQUEST,
    GET_INTERCITY_LIST_SUCCESS,
    GET_INTERCITY_LIST_FAILURE,
    GET_RETURN_INTERCITY_REQUEST,
    GET_RETURN_INTERCITY_SUCCESS,
    GET_RETURN_INTERCITY_FAILURE,
    GET_GOODS_TYPES_REQUEST,
    GET_GOODS_TYPES_SUCCESS,
    GET_GOODS_TYPES_FAILURE,
    GET_LOCATIONS_REQUEST,
    GET_LOCATIONS_SUCCESS,
    GET_LOCATIONS_FAILURE,
    GET_AVAILABLE_CABS_REQUEST,
    GET_AVAILABLE_CABS_SUCCESS,
    GET_AVAILABLE_CABS_FAILURE,
    GET_METER_FARE_REQUEST,
    GET_METER_FARE_SUCCESS,
    GET_METER_FARE_FAILURE,
    GET_PACKAGES_REQUEST,
    GET_PACKAGES_SUCCESS,
    GET_PACKAGES_FAILURE,
    GET_BRANCHES_SUCCESS,
    GET_BRANCHES_FAILURE,
    GET_BRANCHES_REQUEST,
    ADD_ENQUIRY_FAILURE,
    ADD_ENQUIRY_SUCCESS,
    ADD_ENQUIRY_REQUEST,
    GET_NIGHT_FARE_REQUEST,
    GET_NIGHT_FARE_SUCCESS,
    GET_NIGHT_FARE_FAILURE,
    GET_ENQUIRY_BY_DATE_REQUEST,
    GET_ENQUIRY_BY_DATE_SUCCESS,
    GET_ENQUIRY_BY_DATE_FAILURE,
    ENQUIRY_TO_NEW_BOOKING_SUCCESS,
    ENQUIRY_TO_NEW_BOOKING_FAILURE,
    GET_DISTANCE_REQUEST,
    GET_DISTANCE_SUCCESS,
    LONG_TRIP_KM,
    GET_DISTANCE_FAILURE,
    ENQUIRY_TO_NEW_BOOKING_REQUEST,
    GET_NEW_BOOKING_EDIT_FAILURE,
    GET_NEW_BOOKING_EDIT_SUCCESS,
    GET_NEW_BOOKING_EDIT_REQUEST,
    updateEnquirySuccess,
    updateEnquiryFailure,
    UPDATE_ENQUIRY_REQUEST,
} from "../actions/bookingActions";

function* addBookingSaga(action: any): any {
    try {
        const res = yield call(addBookingApi, action.payload);
        //console.log("✅ Add Booking Response:", res.data);

        const result = res.data.data?.[0];

        if (result?.status !== 200) {
            yield put({
                type: ADD_BOOKING_FAILURE,
                payload: result?.message || "Failed to add booking",
            });
            return;
        }

        yield put({
            type: ADD_BOOKING_SUCCESS,
            payload: result,
        });

    } catch (error: any) {
        yield put({
            type: ADD_BOOKING_FAILURE,
            payload: error.response?.data?.message || "Failed to add booking",
        });
    }
}

function* getBranchesSaga(): any {
    try {
        const res = yield call(getBranchesApi);
        yield put({
            type: GET_BRANCHES_SUCCESS,
            payload: Array.isArray(res.data.data) ? res.data.data : []
        });
    } catch (error: any) {
        yield put({
            type: GET_BRANCHES_FAILURE,
            payload: error.response?.data?.message || "Failed to fetch branches",
        });
        //console.log("API ERROR:", error.response || error);
    }
}

function* getCustomerSaga(action: any): any {
    try {
        const { mobileno, cityid } = action.payload;
        const res = yield call(getCustomerApi, mobileno, cityid);
        /* An unknown mobile number comes back as an empty envelope, which the old
           `|| res.data` fallback turned into a truthy "customer" - so the page could
           not tell a new customer from an existing one. Only treat the payload as a
           real record when it carries an identifying field; otherwise null, which
           the reducer reads as "not found". */
        const raw = res.data?.data?.[0] ?? res.data?.data ?? res.data;
        const record =
            raw && (raw.custmerId || raw.customerName || raw.mobileno) ? raw : null;
        yield put({
            type: GET_CUSTOMER_SUCCESS,
            payload: record,
        });
    } catch (error: any) {
        yield put({
            type: GET_CUSTOMER_FAILURE,
            payload: error.response?.data?.message || "Failed to fetch customer",
        });
        //console.log("API ERROR:", error.response || error);
    }
}

function* getVehicleTypesSaga(action: any): any {
    try {
        const { cityid } = action.payload;
        const res = yield call(getVehicleTypesApi, cityid);
        yield put({
            type: GET_VEHICLE_TYPES_SUCCESS,
            payload: Array.isArray(res.data.data) ? res.data.data : []
        });
    } catch (error: any) {
        yield put({
            type: GET_VEHICLE_TYPES_FAILURE,
            payload: error.response?.data?.message || "Failed to fetch vehicles",
        });
        //console.log("API ERROR:", error.response || error);
    }
}

function* getTripTypesSaga(): any {
    try {
        const res = yield call(getTripTypesApi);
        yield put({
            type: GET_TRIP_TYPES_SUCCESS,
            payload: Array.isArray(res.data.data) ? res.data.data : []
        });
    } catch (error: any) {
        yield put({
            type: GET_TRIP_TYPES_FAILURE,
            payload: error.response?.data?.message || "Failed to fetch trip types",
        });
        //console.log("API ERROR:", error.response || error);
    }
}

function* getIntercityListSaga(action: any): any {
    try {
        const { vehicleid, cityid } = action.payload;
        const res = yield call(getIntercityListApi, vehicleid, cityid);
        yield put({
            type: GET_INTERCITY_LIST_SUCCESS,
            payload: Array.isArray(res.data.data) ? res.data.data : []
        });
    } catch (error: any) {
        yield put({
            type: GET_INTERCITY_LIST_FAILURE,
            payload: error.response?.data?.message || "Failed to fetch intercity list",
        });
        //console.log("API ERROR:", error.response || error);
    }
}

function* getReturnIntercitySaga(): any {
    try {
        const res = yield call(getReturnIntercityApi);
        yield put({
            type: GET_RETURN_INTERCITY_SUCCESS,
            payload: Array.isArray(res.data.data) ? res.data.data : []
        });
    } catch (error: any) {
        yield put({
            type: GET_RETURN_INTERCITY_FAILURE,
            payload: error.response?.data?.message || "Failed to fetch return intercity list",
        });
        //console.log("API ERROR:", error.response || error);
    }
}

function* getGoodsTypesSaga(): any {
    try {
        const res = yield call(getGoodsTypesApi);
        yield put({
            type: GET_GOODS_TYPES_SUCCESS,
            payload: Array.isArray(res.data.data) ? res.data.data : []
        });
    } catch (error: any) {
        yield put({
            type: GET_GOODS_TYPES_FAILURE,
            payload: error.response?.data?.message || "Failed to fetch goods types",
        });
        //console.log("API ERROR:", error.response || error);
    }
}

function* getAvailableCabsSaga(action: any): any {
    try {
        const { branchid, vehicletype } = action.payload;
        const res = yield call(getAvailableCabsApi, branchid, vehicletype);
        const cabs = res.data?.data?.data;
        yield put({
            type: GET_AVAILABLE_CABS_SUCCESS,
            payload: Array.isArray(cabs) ? cabs : [],
        });
    } catch (error: any) {
        yield put({
            type: GET_AVAILABLE_CABS_FAILURE,
            payload: error.response?.data?.message || "Failed to fetch available cabs",
        });
    }
}

function* getLocationsSaga(action: any): any {
    try {
        const { cityid } = action.payload;
        const res = yield call(getLocationsApi, cityid);
        yield put({
            type: GET_LOCATIONS_SUCCESS,
            payload: Array.isArray(res.data.data) ? res.data.data : []
        });
    } catch (error: any) {
        yield put({
            type: GET_LOCATIONS_FAILURE,
            payload: error.response?.data?.message || "Failed to fetch locations",
        });
        //console.log("API ERROR:", error.response || error);
    }
}

function* getMeterFareSaga(action: any): any {
    try {
        const { distance, cityid, vehicleid } = action.payload;
        const res = yield call(getMeterFareApi, distance, cityid, vehicleid);
        yield put({
            type: GET_METER_FARE_SUCCESS,
            payload: res.data.data || res.data,
        });
    } catch (error: any) {
        yield put({
            type: GET_METER_FARE_FAILURE,
            payload: error.response?.data?.message || "Failed to fetch meter fare",
        });
        //console.log("API ERROR:", error.response || error);
    }
}

function* getPackagesSaga(action: any): any {
    try {
        const { vehicleid, cityid } = action.payload;
        const res = yield call(getPackagesApi, vehicleid, cityid);
        yield put({
            type: GET_PACKAGES_SUCCESS,
            payload: res.data.data || res.data,
        });
    } catch (error: any) {
        yield put({
            type: GET_PACKAGES_FAILURE,
            payload: error.response?.data?.message || "Failed to fetch packages",
        });
        //console.log("API ERROR:", error.response || error);
    }
}

function* addEnquirySaga(action: any): any {
    try {
        const res = yield call(addEnquiryApi, action.payload);
        const result = res.data.data?.[0];

        if (result?.status !== 200) {
            yield put({
                type: ADD_ENQUIRY_FAILURE,
                payload: result?.message || "Failed to add enquiry",
            });
            return;
        }

        yield put({
            type: ADD_ENQUIRY_SUCCESS,
            payload: result,
        });

    } catch (error: any) {
        yield put({
            type: ADD_ENQUIRY_FAILURE,
            payload: error.response?.data?.message || "Failed to add enquiry",
        });
        //console.log("API ERROR:", error.response || error);
    }
}

function* getNightFareSaga(action: any): any {
    try {
        const { vehicleid, cityid } = action.payload;
        const res = yield call(getNightFareApi, vehicleid, cityid);
        yield put({
            type: GET_NIGHT_FARE_SUCCESS,
            payload: res.data.data || res.data,
        });
    } catch (error: any) {
        yield put({
            type: GET_NIGHT_FARE_FAILURE,
            payload: error.response?.data?.message || "Failed to fetch night fare",
        });
        //console.log("API ERROR:", error.response || error);
    }
}

function* getEnquiryByDateSaga(action: any): any {
    try {
        const { branchid, fromdate, todate } = action.payload;
        const res = yield call(getEnquiryByDateApi, branchid, fromdate, todate);
        yield put({
            type: GET_ENQUIRY_BY_DATE_SUCCESS,
            payload: res.data.data || { data: [], tablelength: 0 },
        });
    } catch (error: any) {
        // Backend returns 404 when no records found — treat as empty result, not error
        if (error.response?.status === 404) {
            yield put({
                type: GET_ENQUIRY_BY_DATE_SUCCESS,
                payload: { data: [], tablelength: 0 },
            });
            return;
        }
        yield put({
            type: GET_ENQUIRY_BY_DATE_FAILURE,
            payload: error.response?.data?.message || "Failed to fetch enquiries",
        });
    }
}

function* enquiryToNewBookingSaga(action: any): any {
    try {
        const res = yield call(enquiryToNewBookingApi, action.payload);
        const result = res.data.data?.[0] || res.data;

        if (result?.status !== 200 && result?.statusCode !== 200 && !result?.success && !res.data.success && res.data.status !== 200) {
            yield put({
                type: ENQUIRY_TO_NEW_BOOKING_FAILURE,
                payload: result?.message || res.data.message || "Failed to convert enquiry to booking",
            });
            return;
        }

        yield put({
            type: ENQUIRY_TO_NEW_BOOKING_SUCCESS,
            payload: result,
        });

    } catch (error: any) {
        yield put({
            type: ENQUIRY_TO_NEW_BOOKING_FAILURE,
            payload: error.response?.data?.message || "Failed to convert enquiry to booking",
        });
        //console.log("API ERROR:", error.response || error);
    }
}

//getDistanceSaga
function* getDistanceSaga(action: any): any {
    try {
        const { fromlat, fromlong, tolat, tolong, cityid, vehicleid, faretype, applyLongTripRule } = action.payload;
        const res = yield call(getDistanceApi, fromlat, fromlong, tolat, tolong);
        const distanceData = res.data.data?.[0];

        yield put({
            type: GET_DISTANCE_SUCCESS,
            payload: distanceData,
        });

        if (distanceData && distanceData.distance) {
            const cleanDistance = distanceData.distance.split(" ")[0];

            // Fetch the fare the form is actually going to use, not both. The
            // Add Booking form flips itself to Intercity at LONG_TRIP_KM, so a
            // meter fare fetched here would be thrown away a render later.
            if (applyLongTripRule && parseFloat(cleanDistance) >= LONG_TRIP_KM) {
                yield put({
                    type: GET_INTERCITY_LIST_REQUEST,
                    payload: { vehicleid, cityid }
                });
            } else if (!faretype || faretype === 1) {
                yield put({
                    type: GET_METER_FARE_REQUEST,
                    payload: { distance: cleanDistance, cityid, vehicleid }
                });
            }
        }

    } catch (error: any) {
        yield put({
            type: GET_DISTANCE_FAILURE,
            payload: error.response?.data?.message || "Failed to fetch distance",
        });
    }
}

function* getCompaniesSaga(action: any): any {
    try {
        const { cityid } = action.payload;
        const res = yield call(getCompaniesApi, cityid);

        const data = Array.isArray(res.data.data) ? res.data.data : [];
        const filtered = data.filter((c: any) => c.companyname || c.customername);

        yield put({
            type: "GET_COMPANIES_SUCCESS",
            payload: filtered,
        });
    } catch (error: any) {
        yield put({
            type: "GET_COMPANIES_FAILURE",
            payload: error.response?.data?.message || "Failed to fetch companies",
        });
    }
}

function* getNewBookingEditSaga(action: any): any {
    try {
        const { bookingid } = action.payload;
        const res = yield call(getNewBookingEditApi, bookingid);

        const data = res.data.data?.[0] || null;

        if (!data) {
            yield put({
                type: GET_NEW_BOOKING_EDIT_FAILURE,
                payload: "Booking not found",
            });
            return;
        }

        yield put({
            type: GET_NEW_BOOKING_EDIT_SUCCESS,
            payload: data,
        });
    } catch (error: any) {
        yield put({
            type: GET_NEW_BOOKING_EDIT_FAILURE,
            payload: error.response?.data?.message || "Failed to fetch booking",
        });
    }
}

function* handleUpdateEnquiry(action: any): any {
    try {
        const response: any = yield call(updateEnquiryApi, action.payload);
        yield put(updateEnquirySuccess(response.data.message));
    } catch (error: any) {
        const errorMessage =
            error?.response?.data?.message ?? "Failed to update enquiry";
        yield put(updateEnquiryFailure(errorMessage));
    }
}

function* enquiryAssignTripSaga(action: any): any {
    try {
        const res = yield call(enquiryAssignTripApi, action.payload);
        const result = res.data.data?.[0] || res.data;

        if (result?.status !== 200 && result?.statusCode !== 200 && !result?.success && !res.data.success && res.data.status !== 200) {
            yield put({
                type: "ENQUIRY_ASSIGN_TRIP_FAILURE",
                payload: result?.message || res.data.message || "Failed to assign trip",
            });
            return;
        }

        yield put({
            type: "ENQUIRY_ASSIGN_TRIP_SUCCESS",
            payload: result,
        });

    } catch (error: any) {
        yield put({
            type: "ENQUIRY_ASSIGN_TRIP_FAILURE",
            payload: error.response?.data?.message || "Failed to assign trip",
        });
    }
}

export default function* bookingSaga() {
    yield takeLatest(ADD_BOOKING_REQUEST, addBookingSaga);
    yield takeLatest(GET_BRANCHES_REQUEST, getBranchesSaga);
    yield takeLatest(GET_CUSTOMER_REQUEST, getCustomerSaga);
    yield takeLatest(GET_VEHICLE_TYPES_REQUEST, getVehicleTypesSaga);
    yield takeLatest(GET_TRIP_TYPES_REQUEST, getTripTypesSaga);
    yield takeLatest(GET_INTERCITY_LIST_REQUEST, getIntercityListSaga);
    yield takeLatest(GET_RETURN_INTERCITY_REQUEST, getReturnIntercitySaga);
    yield takeLatest(GET_GOODS_TYPES_REQUEST, getGoodsTypesSaga);
    yield takeLatest(GET_LOCATIONS_REQUEST, getLocationsSaga);
    yield takeLatest(GET_AVAILABLE_CABS_REQUEST, getAvailableCabsSaga);
    yield takeLatest(GET_METER_FARE_REQUEST, getMeterFareSaga);
    yield takeLatest(GET_PACKAGES_REQUEST, getPackagesSaga);
    yield takeLatest(ADD_ENQUIRY_REQUEST, addEnquirySaga);
    yield takeLatest(GET_NIGHT_FARE_REQUEST, getNightFareSaga);
    yield takeLatest(GET_ENQUIRY_BY_DATE_REQUEST, getEnquiryByDateSaga);
    yield takeLatest(ENQUIRY_TO_NEW_BOOKING_REQUEST, enquiryToNewBookingSaga);
    yield takeLatest(GET_DISTANCE_REQUEST, getDistanceSaga);
    yield takeLatest("GET_COMPANIES_REQUEST", getCompaniesSaga);
    yield takeLatest(GET_NEW_BOOKING_EDIT_REQUEST, getNewBookingEditSaga);
    yield takeLatest(UPDATE_ENQUIRY_REQUEST, handleUpdateEnquiry);
    yield takeLatest("ENQUIRY_ASSIGN_TRIP_REQUEST", enquiryAssignTripSaga);
}
